import React from "react";
import { Grid } from "@material-ui/core";
import MaintenancePageImage from "../../../assets/images/MaintenancePage.png";

export default function MaintenancePage() {
  return (
    <Grid
      container
      alignItems="center"
      justifyContent="center"
      style={{
        width: "100vw",
        height: "100dvh",
        overflow: "hidden",
        backgroundColor: "#f4f8ff",
      }}
    >
      <img
        src={MaintenancePageImage}
        alt="سایت در حال بروزرسانی است"
        style={{
          display: "block",
          width: "100%",
          height: "100%",
          objectFit: "contain",
        }}
      />
    </Grid>
  );
}